import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {stopAudioPlayer} from "store/actions/audioPlayer";
import View from "./View";

function Container(props) {
  const dispatch = useDispatch();
  const audioPlayer = useSelector(state => state.audioPlayer);

  useEffect(() => {
    restartAudio();
  }, [audioPlayer.playingComponent]);

  const restartAudio = () => {
    const audioElement = document.querySelector("#audio-player");
    if (audioElement) audioElement.currentTime = 0;
  };

  const onEndedAudio = () => {
    dispatch(stopAudioPlayer());
  };

  return (
    <View
      isPlaying={audioPlayer.isPlaying}
      audioSource={audioPlayer.source}
      onEndedAudio={onEndedAudio}
    />
  );
}

export default Container;
